import React from 'react'

function NormalLoader() {
  return (
     <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-24 w-24 border-b-2 border-blue-900"></div>
      </div>
  )
}

export default NormalLoader
